import styled from 'styled-components';
import theme from '../../theme';
import { Button } from '../../components';

const Container = styled.div`
  margin-bottom: 80px;

  > div {
    margin-top: 20px;

    > span {
      margin-left: 20px;
      font-size: 12px;
      font-weight: 400;
      color: ${theme.textDark};
    }

    > div {
      display: flex;
      margin-top: 5px;
      padding: 0 20px;
      overflow-x: auto;
      scroll-snap-type: x mandatory;
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;

      &::-webkit-scrollbar {
          width: 5px;
          height: 5px;
      }

      &::-webkit-scrollbar-thumb {
          background: transparent;
          border-radius: 5px;
      }

      &::-webkit-scrollbar-track {
          background: transparent;
      }
    }
  }

  button + button {
    margin-left: 10px;
  }

  > ul { 
    margin: 0 20px;
    list-style-type: none;

    > li, span {
      font-size: 14px;
      font-weight: 700;
      color: ${theme.textDark};
      margin-bottom: 5px;
      display: block;
      margin-top: 20px;
    } 
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  border-left: 2px solid ${theme.textDark};
  padding-left: 10px;
  margin-top: 10px;
  cursor: pointer;

  > span {
    margin: 0 0 0 auto !important;
    font-size: 13px !important;
    font-weight: 700 !important;
    color: ${theme.primaryColor} !important;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 28px;
  padding-bottom: 5px;
`;

const ExhibitorHeader = styled.div`
    display: flex;
    align-items: center;

    img {
        width: 24px;
        height: 24px;
    }

    div {
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        
        strong {
            font-size: 11px;
            font-weight: 700;
            color: ${theme.textDark};
        }

        small {
            font-size: 11px;
            font-weight: 400;
            color: ${theme.textDark};
        }
    }
`;

const AmountHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  svg {
    width: 13px;
    height: 13px;
  }

  span {
    font-size: 16px;
    font-weight: 900;
    color: ${theme.textDark} !important;
  }
`;

const NoData = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.textDark};
  text-align: center;
  margin-top: calc(50vh - 70px);
`;

const FilterButton = styled(Button)`
  && {
    border-radius: 30px;
    min-width: 100px;
  }
`;


export {
  Container,
  Header,
  ExhibitorHeader,
  AmountHeader,
  Content,
  NoData,
  FilterButton
};